import { h } from 'preact';
import { useRouter } from 'preact-router';
import { isStudioRoute } from 'src/common/utils';
import { ROUTE, ROUTE_STUDIO } from 'src/common/constants';
import * as styles from './styles.less';

const Footer = () => {
    const router = useRouter()[0];
    const section = router?.url;
    const routes = isStudioRoute(section) ? ROUTE_STUDIO : ROUTE;

    return (
        <footer class={styles.footer}>
            <nav class={styles.footer__nav}>
                <a href={routes.CONTACT_US} class={styles.footer__nav_item}>
                    Contact Us
                </a>
                <a href={routes.FAQ} class={styles.footer__nav_item}>
                    F.A.Q.
                </a>
                <a href={routes.TERMS_AND_CONDITIONS} class={styles.footer__nav_item}>
                    Terms & Conditions
                </a>
                <a href={routes.PRIVACY_POLICY} class={styles.footer__nav_item}>
                    Privacy Policy
                </a>
            </nav>
            <div class={styles.footer__slogan}>
                <div class={styles.footer__slogan_lside}>webcams</div>
                <div class={styles.footer__logo} />
                <div class={styles.footer__slogan_rside}>around the world</div>
            </div>
            <p class={styles.footer__copy}>All persons who appear in any visual depiction contained in this site were/are eighteen years of age or older at the time of the creation of such depictions.</p>
        </footer>
    );
};

export default Footer;
